import { ProductKeys1P, type ProductKeys } from '../common/constants/types';
import { ProductKeys3P } from '../common/ui/configs/types';

/**
 * Array of all known product keys (both 1P and 3P).
 * Used to validate or enumerate all supported hardcoded products.
 *
 * Note: This does not include dynamically-registered Forge connector keys
 * (ForgeConnectorProductKey), which are open-ended string values.
 */
export const allProductKeys: ProductKeys[] = [
	...Object.values(ProductKeys1P),
	...Object.values(ProductKeys3P),
];
